import React, { useState, useCallback, useEffect } from 'react'
import { MdEmail, MdSmartphone, MdMessage, MdNotifications, MdDescription, MdError, MdEdit, MdCalendarToday, MdAccessTime, MdInfo } from "react-icons/md";
import { Users, Clock, Globe, FileCircleExclamation, CircleInfo, UserTie, CloudUploadAlt, CircleDotted, Question, HourglassHalf, TriangleExclamation, Save, CircleCheck } from '../../../../../../../components/icons/Icons';
import { Switch } from '@mui/material';
import { Form } from 'react-bootstrap';
import { ToastContainer, toast } from "react-toastify";
// ---------------------------------------------------
import { indianLoaclStrigNumber, normalNumber, isValidIndianFormattedNumber, isValidIndianNumber, useSelect } from '../../../../../../../services/commonServices';
import { getNotificationRulePath, saveNotificationRulePath } from '../../../../../../../services/config';
import { getTdsNotification, initNotiRules, tdsSaveData, initTdsState } from '../../../../../../../redux/slices/tdsSlice';
import { useDispatch } from 'react-redux';


const Notifications = () => {
  const [notifications, setNotifications] = useState({
    form12BB: true,
    missingProofs: true,
    hrEditRequests: true,
    deadlineReminders: true,
  });

  const [selectedChannels, setSelectedChannels] = useState({
    global: ["email", "push", "sms", "inApp"],
    form12BB: ["email", "inApp", "sms"],
    missingProofs: ["email", "inApp", "sms"],
    hrEditRequests: ["email", "push", "inApp"],
  });

  const [deadlineChecks, setDeadlineChecks] = useState({
    threeDays: true,
    oneDay: true,
  });

  const toggleNotification = (key) => {
    setNotifications((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const toggleChannel = (section, channel) => {
    setSelectedChannels((prev) => ({
      ...prev,
      [section]: prev[section].includes(channel)
        ? prev[section].filter((c) => c !== channel)
        : [...prev[section], channel],
    }));
  };

  const ChannelButton = ({ icon: Icon, label, active, onClick }) => (
    <button className={`channel-btn ${active == true ? "active" : ""}`} onClick={onClick}>
      <Icon size={16} />
      <span>{label}</span>
    </button>
  );

  const user = JSON.parse(localStorage.getItem("user_data")) || {}
  const dispatch = useDispatch()
  const tdsStore = useSelect("tds")

  const [notiState, setNotiState] = useState({
    userId: user.user_id,
    "notificationStartTime": "",
    "notificationEndTime": "",
    "defaultNotificationChannel": "",
    "isAllowForm12bb": "",
    "form12bReminderFrequency": "",
    "form12bStartReminder": "",
    "form12bNotificationChannel": [],
    "isAllowMissingProofAlert": "",
    "missingProofAlertTiming": "",
    "missingProofFollowUpFreq": "",
    "missingProofNotificationChannel": [],
    "isAllowHrEditRequest": "",
    "hrEditNotificationChannel": [],
    "isAllowDeadlineReminder": "",
    "deadLinePriorityType": "",
    "deadLineNotificationChannel": [],
    "isNewFormSubmission": "",
    "formNotificationFreq": "",
    "formBatchSize": "",
    "formNotificationChannel": [],
    "isAllowProofUpload": "",
    "proofUploadNotificationMode": "",
    "proofUploadPriorityFilter": "",
    "proofUploadNotificationChannel": [],
    "isAllowPendingReviewAlert": "",
    "alertThreshold": "",
    "reminderFreq": "",
    "pendingReviewNotificationChannel": [],
    "isAllowEscalationNotification": "",
    "escalationThreshold": "",
    "escalationLevel": "",
    "escalationNotificationChannel": []
  })

  const handleChanleChange = (name, value) => {
    setNotiState((pre) => ({
      ...pre,
      [name]: value
    }))
  }

  const getListValidatio = useCallback(() => {
    dispatch(getTdsNotification(`${getNotificationRulePath}${user.user_id}`))
  }, [])

  useEffect(() => {
    getListValidatio()
  }, [])

  const handleInputChange = ({ target: { value, name } }) => {
    setNotiState((pre) => ({
      ...pre,
      [name]: value
    }))
  }

  const handleSwitchChange = ({ target: { name, checked } }) => {
    setNotiState((pre) => ({
      ...pre,
      [name]: checked ? "1" : "0"
    }))
  }

   const toggleForm12bNotificationChannel = (value) => {
    setNotiState((prev) => ({
      ...prev,
      form12bNotificationChannel: prev.form12bNotificationChannel.includes(value)
        ? prev.form12bNotificationChannel.filter((v) => v !== value) // remove
        : [...prev.form12bNotificationChannel, value] // add
    }));
  };

  const toggleMissingProofNotificationChannel = (value) => {
    setNotiState((prev) => ({
      ...prev,
      missingProofNotificationChannel: prev.missingProofNotificationChannel.includes(value)
        ? prev.missingProofNotificationChannel.filter((v) => v !== value) // remove
        : [...prev.missingProofNotificationChannel, value] // add
    }));
  };

  const toggleHrEditNotificationChannel = (value) => {
    setNotiState((prev) => ({
      ...prev,
      hrEditNotificationChannel: prev.hrEditNotificationChannel.includes(value)
        ? prev.hrEditNotificationChannel.filter((v) => v !== value) // remove
        : [...prev.hrEditNotificationChannel, value] // add
    }));
  };

  const toggleDeadLineNotificationChannel = (value) => {
    setNotiState((prev) => ({
      ...prev,
      deadLineNotificationChannel: prev.deadLineNotificationChannel.includes(value)
        ? prev.deadLineNotificationChannel.filter((v) => v !== value) // remove
        : [...prev.deadLineNotificationChannel, value] // add
    }));
  };

  const toggleFormNotificationChannel = (value) => {
    setNotiState((prev) => ({
      ...prev,
      formNotificationChannel: prev.formNotificationChannel.includes(value)
        ? prev.formNotificationChannel.filter((v) => v !== value) // remove
        : [...prev.formNotificationChannel, value] // add
    }));
  };

  const toggleProofUploadNotificationChannel = (value) => {
    setNotiState((prev) => ({
      ...prev,
      proofUploadNotificationChannel: prev.proofUploadNotificationChannel.includes(value)
        ? prev.proofUploadNotificationChannel.filter((v) => v !== value) // remove
        : [...prev.proofUploadNotificationChannel, value] // add
    }));
  };

  const togglePendingReviewNotificationChannel = (value) => {
    setNotiState((prev) => ({
      ...prev,
      pendingReviewNotificationChannel: prev.pendingReviewNotificationChannel.includes(value)
        ? prev.pendingReviewNotificationChannel.filter((v) => v !== value) // remove
        : [...prev.pendingReviewNotificationChannel, value] // add
    }));
  };

  const toggleEscalationNotificationChannel = (value) => {
    setNotiState((prev) => ({
      ...prev,
      escalationNotificationChannel: prev.escalationNotificationChannel.includes(value)
        ? prev.escalationNotificationChannel.filter((v) => v !== value) // remove
        : [...prev.escalationNotificationChannel, value] // add
    }));
  };
  

  const resetForm = () => {
    setNotiState((pre) => ({
      ...pre,
      userId: user.user_id,
      "notificationStartTime": "",
      "notificationEndTime": "",
      "defaultNotificationChannel": "",
      "isAllowForm12bb": "",
      "form12bReminderFrequency": "",
      "form12bStartReminder": "",
      "form12bNotificationChannel": [],
      "isAllowMissingProofAlert": "",
      "missingProofAlertTiming": "",
      "missingProofFollowUpFreq": "",
      "missingProofNotificationChannel": [],
      "isAllowHrEditRequest": "",
      "hrEditNotificationChannel": [],
      "isAllowDeadlineReminder": "",
      "deadLinePriorityType": "",
      "deadLineNotificationChannel": [],
      "isNewFormSubmission": "",
      "formNotificationFreq": "",
      "formBatchSize": "",
      "formNotificationChannel": [],
      "isAllowProofUpload": "",
      "proofUploadNotificationMode": "",
      "proofUploadPriorityFilter": "",
      "proofUploadNotificationChannel": [],
      "isAllowPendingReviewAlert": "",
      "alertThreshold": "",
      "reminderFreq": "",
      "pendingReviewNotificationChannel": [],
      "isAllowEscalationNotification": "",
      "escalationThreshold": "",
      "escalationLevel": "",
      "escalationNotificationChannel": []
    }))
  }

  const submitNotificationRules = (e) => {
    e.preventDefault()

    const formData = {
      path: saveNotificationRulePath,
      data: {
        userId: user.user_id,
        "notificationStartTime": notiState.notificationStartTime,
        "notificationEndTime": notiState.notificationEndTime,
        "defaultNotificationChannel": notiState.defaultNotificationChannel,
        "isAllowForm12bb": notiState.isAllowForm12bb,
        "form12bReminderFrequency": notiState.form12bReminderFrequency,
        "form12bStartReminder": notiState.form12bStartReminder,
        "form12bNotificationChannel": notiState.form12bNotificationChannel.toString(),
        "isAllowMissingProofAlert": notiState.isAllowMissingProofAlert,
        "missingProofAlertTiming": notiState.missingProofAlertTiming,
        "missingProofFollowUpFreq": notiState.missingProofFollowUpFreq,
        "missingProofNotificationChannel": notiState.missingProofNotificationChannel.toString(),
        "isAllowHrEditRequest": notiState.isAllowHrEditRequest,
        "hrEditNotificationChannel": notiState.hrEditNotificationChannel.toString(),
        "isAllowDeadlineReminder": notiState.isAllowDeadlineReminder,
        "deadLinePriorityType": notiState.deadLinePriorityType,
        "deadLineNotificationChannel": notiState.deadLineNotificationChannel.toString(),
        "isNewFormSubmission": notiState.isNewFormSubmission,
        "formNotificationFreq": notiState.formNotificationFreq,
        "formBatchSize": notiState.formBatchSize,
        "formNotificationChannel": notiState.formNotificationChannel.toString(),
        "isAllowProofUpload": notiState.isAllowProofUpload,
        "proofUploadNotificationMode": notiState.proofUploadNotificationMode,
        "proofUploadPriorityFilter": notiState.proofUploadPriorityFilter,
        "proofUploadNotificationChannel": notiState.proofUploadNotificationChannel.toString(),
        "isAllowPendingReviewAlert": notiState.isAllowPendingReviewAlert,
        "alertThreshold": notiState.alertThreshold,
        "reminderFreq": notiState.reminderFreq,
        "pendingReviewNotificationChannel": notiState.pendingReviewNotificationChannel.toString(),
        "isAllowEscalationNotification": notiState.isAllowEscalationNotification,
        "escalationThreshold": notiState.escalationThreshold,
        "escalationLevel": notiState.escalationLevel,
        "escalationNotificationChannel": notiState.escalationNotificationChannel.toString()
      }
    }
    const isAllEmpty = Object.entries(notiState)
      .filter(([key]) => key !== "userId") // userId को exclude किया
      .every(([_, value]) => value === "" || value === null || value === undefined || value === " ");
    if (isAllEmpty) {
      toast.error("Please select required fields first")
    } else {
      dispatch(tdsSaveData(formData))
    }

  }

  useEffect(() => {
    if (tdsStore.tdsSuccess) {
      toast.success(tdsStore.tdsMessage)
      dispatch(initTdsState())
    }

    if (tdsStore.tdsNotiSuccess) {
      setNotiState((pre) => ({
        ...pre,
        userId: user.user_id,
        "notificationStartTime": tdsStore.tdsNotiData.notificationStartTime,
        "notificationEndTime": tdsStore.tdsNotiData.notificationEndTime,
        "defaultNotificationChannel": tdsStore.tdsNotiData.defaultNotificationChannel,
        "isAllowForm12bb": tdsStore.tdsNotiData.isAllowForm12bb,
        "form12bReminderFrequency": tdsStore.tdsNotiData.form12bReminderFrequency,
        "form12bStartReminder": tdsStore.tdsNotiData.form12bStartReminder,
        "form12bNotificationChannel": tdsStore.tdsNotiData.form12bNotificationChannel.split(","),
        "isAllowMissingProofAlert": tdsStore.tdsNotiData.isAllowMissingProofAlert,
        "missingProofAlertTiming": tdsStore.tdsNotiData.missingProofAlertTiming,
        "missingProofFollowUpFreq": tdsStore.tdsNotiData.missingProofFollowUpFreq,
        "missingProofNotificationChannel": tdsStore.tdsNotiData.missingProofNotificationChannel.split(","),
        "isAllowHrEditRequest": tdsStore.tdsNotiData.isAllowHrEditRequest,
        "hrEditNotificationChannel": tdsStore.tdsNotiData.hrEditNotificationChannel.split(","),
        "isAllowDeadlineReminder": tdsStore.tdsNotiData.isAllowDeadlineReminder,
        "deadLinePriorityType": tdsStore.tdsNotiData.deadLinePriorityType,
        "deadLineNotificationChannel": tdsStore.tdsNotiData.deadLineNotificationChannel.split(","),
        "isNewFormSubmission": tdsStore.tdsNotiData.isNewFormSubmission,
        "formNotificationFreq": tdsStore.tdsNotiData.formNotificationFreq,
        "formBatchSize": tdsStore.tdsNotiData.formBatchSize,
        "formNotificationChannel": tdsStore.tdsNotiData.formNotificationChannel.split(","),
        "isAllowProofUpload": tdsStore.tdsNotiData.isAllowProofUpload,
        "proofUploadNotificationMode": tdsStore.tdsNotiData.proofUploadNotificationMode,
        "proofUploadPriorityFilter": tdsStore.tdsNotiData.proofUploadPriorityFilter,
        "proofUploadNotificationChannel": tdsStore.tdsNotiData.proofUploadNotificationChannel.split(","),
        "isAllowPendingReviewAlert": tdsStore.tdsNotiData.isAllowPendingReviewAlert,
        "alertThreshold": tdsStore.tdsNotiData.alertThreshold,
        "reminderFreq": tdsStore.tdsNotiData.reminderFreq,
        "pendingReviewNotificationChannel": tdsStore.tdsNotiData.pendingReviewNotificationChannel.split(","),
        "isAllowEscalationNotification": tdsStore.tdsNotiData.isAllowEscalationNotification,
        "escalationThreshold": tdsStore.tdsNotiData.escalationThreshold,
        "escalationLevel": tdsStore.tdsNotiData.escalationLevel,
        "escalationNotificationChannel": tdsStore.tdsNotiData.escalationNotificationChannel.split(",")
      }))
      dispatch(initNotiRules())
    }


  }, [tdsStore])

  return (
    <div>

      <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
        <div>
          <h3 className='color-white font-weight-200'>Notifications & Reminders</h3>
          <span className='color-gray font-weight-200 font-14'>Configure automated notifications for employees and administrators</span>
        </div>
        <div className='d-flex align-items-center gap-2'>
          <CircleCheck class_name={"green-text"} /> <span className='color-white font-weight-200 font-14'>All changes saved</span> <span className='color-gray font-weight-200 font-14'>Last updated: 1 hour ago</span>
        </div>
      </div>

      {/* Global Settings */}
      <section className="setting-border height-auto  mb-4">

        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'>  <Globe class_name="section-icon text-purple" /> Global Settings </h3>
          <span className='color-gray font-14'> System-wide preferences </span>
        </div>


        <div className="global-content">
          <div className="time-window-section">
            <div className="section-header">
              <span className='padding-5-purple'>
                <Clock class_name="section-icon text-purple" />
              </span>
              <div>
                <h3 className='color-white'>Notification Time Window</h3>
                <p>Define when notifications should be sent to avoid off-hours disturbance</p>
              </div>
            </div>

            <div className="time-inputs">
              <div className="time-input-group">
                <label>Start Time</label>
                <input type="time" name="notificationStartTime" defaultValue={notiState.notificationStartTime} onChange={handleInputChange} />
                <button className="time-action-btn">
                  <MdAccessTime size={16} />
                </button>
              </div>
              <span className="time-separator">to</span>
              <div className="time-input-group">
                <label>End Time</label>
                <input type="time" name="notificationEndTime" defaultValue={notiState.notificationEndTime} onChange={handleInputChange} />
                <button className="time-action-btn">
                  <MdAccessTime size={16} />
                </button>
              </div>
            </div>
          </div>

          <div className="channels-section">
            <div className="section-header">
              <MdSmartphone size={20} className="section-icon text-purple" />
              <div>
                <h3 className='color-white'>Default Notification Channels</h3>
                <p>Select default channels for new notification rules</p>
              </div>
            </div>
            <div className="channel-buttons">
              <ChannelButton
                icon={MdEmail}
                label={`Email`}
                active={notiState.defaultNotificationChannel === "email" ? true : false}
                onClick={() => handleChanleChange("defaultNotificationChannel", "email")}
              />
              <ChannelButton
                icon={MdSmartphone}
                label={`Push`}
                active={notiState.defaultNotificationChannel === "push" ? true : false}
                onClick={() => handleChanleChange("defaultNotificationChannel", "push")}
              />
              <ChannelButton
                icon={MdMessage}
                label={`SMS`}
                active={notiState.defaultNotificationChannel === "sms" ? true : false}
                onClick={() => handleChanleChange("defaultNotificationChannel", "sms")}
              />
              <ChannelButton
                icon={MdNotifications}
                label={`InApp`}
                active={notiState.defaultNotificationChannel === "inApp" ? true : false}
                onClick={() => handleChanleChange("defaultNotificationChannel", "inApp")}
              />
            </div>

          </div>
        </div>
      </section>

      {/* Global Settings */}
      <section className="setting-border height-auto  mb-4">

        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'> <Users class_name="section-icon text-purple" /> Employee Notifications </h3>
          <span className='color-gray font-14'> 4 notification types</span>
        </div>


        <div className="p-4">

          <div className="time-window-sections">

            <div className='d-flex align-items-center justify-content-between gap-2'>
              <div className="section-header">
                <span className='padding-5-purple'>
                  <FileCircleExclamation class_name="section-icon text-purple" />
                </span>
                <div>
                  <h3 className='color-white'>Form 12BB Submission Reminder</h3>
                  <p>Remind employees to submit their Form 12BB</p>
                </div>
              </div>

              <Switch onChange={handleSwitchChange} name="isAllowForm12bb" checked={notiState.isAllowForm12bb === "1"} />
            </div>

            <div className="time-inputs">
              <div className="time-input-group">
                <label>Reminder Frequency</label>
                <Form.Group>
                  <Form.Select name="form12bReminderFrequency" onChange={handleInputChange} value={notiState.form12bReminderFrequency}>
                    <option value="">Select Reminder Frequency</option>
                    <option value="Daily">Daily</option>
                    <option value="Weekly">Weekly</option>
                  </Form.Select>
                </Form.Group>
                {/* <button className="time-action-btn">
                  <MdAccessTime size={16} />
                </button> */}
              </div>

              <div className="time-input-group">
                <label>Start Reminders</label>
                <Form.Group>
                  <Form.Select
                    name="form12bStartReminder"
                    onChange={handleInputChange}
                    value={notiState.form12bStartReminder}
                  >
                    <option value="">Select start reminder</option>
                    <option value="Immediately">Immediately</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>

          <h3 className='color-gray font-14 font-weight-200 mt-3'>Notification Channels</h3>
          <div className="channels-section">

            <div className="channel-buttons mt-2">
              <ChannelButton
                icon={MdEmail}
                label="Email"
                active={notiState.form12bNotificationChannel.includes("email")}
                onClick={() => toggleForm12bNotificationChannel("email")}
              />

              <ChannelButton
                icon={MdMessage}
                label="SMS"
                active={notiState.form12bNotificationChannel.includes("sms")}
                onClick={() => toggleForm12bNotificationChannel("sms")}
              />
              <ChannelButton
                icon={MdNotifications}
                label="In-App"
                active={notiState.form12bNotificationChannel.includes("inApp")}
                onClick={() => toggleForm12bNotificationChannel("inApp")}
              />
            </div>

          </div>
        </div>
      </section>

      {/* ---------- */}
      <section className="setting-border height-auto  mb-4">

        <div className="p-4">

          <div className="time-window-sections">

            <div className='d-flex align-items-center justify-content-between gap-2'>
              <div className="section-header">
                <span className='padding-5-purple'>
                  <FileCircleExclamation class_name="section-icon text-purple" />
                </span>
                <div>
                  <h3 className='color-white'>Missing Proofs Alert</h3>
                  <p>Alert employees when supporting documents are missing</p>
                </div>
              </div>

              <Switch
                name="isAllowMissingProofAlert"
                onChange={handleSwitchChange}
                checked={notiState.isAllowMissingProofAlert === "1"}
              />
            </div>

            <div className="time-inputs">
              <div className="time-input-group">
                <label>Alert Timing</label>
                <Form.Group>
                  <Form.Select
                    name="missingProofAlertTiming"
                    onChange={handleInputChange}
                    value={notiState.missingProofAlertTiming}
                  >
                    <option value="">Select Alert Timing</option>
                    <option value="Immediately after submission">Immediately after submission</option>
                  </Form.Select>
                </Form.Group>
                {/* <button className="time-action-btn">
                  <MdAccessTime size={16} />
                </button> */}
              </div>

              <div className="time-input-group">
                <label>Follow-up Frequency</label>
                <Form.Group>
                  <Form.Select
                    name="missingProofFollowUpFreq"
                    onChange={handleInputChange}
                    value={notiState.missingProofFollowUpFreq}
                  >
                    <option value="">Select Follow-up Frequency</option>
                    <option value={"Daily"}>Daily</option>
                    <option value={"Weekly"}>Weekly</option>
                    <option value={"Monthly"}>Monthly</option>
                    <option value={"Yearly"}>Yearly</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>

          <h3 className='color-gray font-14 font-weight-200 mt-3'>Notification Channels</h3>
          <div className="channels-section">

            <div className="channel-buttons mt-2">
              <ChannelButton
                icon={MdEmail}
                label="Email"
                active={notiState.missingProofNotificationChannel.includes("email")}
                onClick={() => toggleMissingProofNotificationChannel("email")}
              />

              <ChannelButton
                icon={MdMessage}
                label="SMS"
                active={notiState.missingProofNotificationChannel.includes("sms")}
                onClick={() => toggleMissingProofNotificationChannel("sms")}
              />
              <ChannelButton
                icon={MdNotifications}
                label="In-App"
                active={notiState.missingProofNotificationChannel.includes("inApp")}
                onClick={() => toggleMissingProofNotificationChannel("inApp")}
              />
            </div>

          </div>
        </div>
      </section>

      {/* ---------- */}
      <section className="setting-border height-auto  mb-4">

        <div className="p-4">

          <div className="time-window-sections">

            <div className='d-flex align-items-center justify-content-between gap-2'>
              <div className="section-header">
                <span className='padding-5-purple'>
                  <FileCircleExclamation class_name="section-icon text-purple" />
                </span>
                <div>
                  <h3 className='color-white'>HR Edit Requests</h3>
                  <p>Notify employees when HR requests form edits</p>
                </div>
              </div>

              <Switch name="isAllowHrEditRequest" onChange={handleSwitchChange} checked={notiState.isAllowHrEditRequest === "1"} />
            </div>

            <div className='setting-switch-enbl-dsbl mt-2'>
              <div className='content px-4 d-flex align-items-center justify-content-start'>
                <CircleInfo class_name={'text-info'} />
                <div>
                  <h5 className='color-gray font-weight-200 font-14'>High Priority: These notifications are sent immediately when HR requests edits.</h5>
                  <h5 className='color-gray font-weight-200 font-14'>Employees receive instant alerts via email and push notifications.</h5>
                </div>
              </div>
            </div>
          </div>

          <h3 className='color-gray font-14 font-weight-200 mt-3'>Notification Channels</h3>
          <div className="channels-section">

            <div className="channel-buttons mt-2">
              <ChannelButton
                icon={MdEmail}
                label="Email"
                active={notiState.hrEditNotificationChannel.includes("email")}
                onClick={() => toggleHrEditNotificationChannel("email")}
              />

              <ChannelButton
                icon={MdMessage}
                label="SMS"
                active={notiState.hrEditNotificationChannel.includes("sms")}
                onClick={() => toggleHrEditNotificationChannel("sms")}
              />
              <ChannelButton
                icon={MdNotifications}
                label="In-App"
                active={notiState.hrEditNotificationChannel.includes("inApp")}
                onClick={() => toggleHrEditNotificationChannel("inApp")}
              />
            </div>

          </div>
        </div>
      </section>
      {/* Employee Notifications */}
      <section className="">

        <div className="deadline-options setting-border height-auto p-4 mb-4">

          <div className='d-flex align-items-center justify-content-between gap-2'>
            <div className="section-header">
              <span className='padding-5-purple'>
                <FileCircleExclamation class_name="section-icon text-purple" />
              </span>
              <div>
                <h3 className='color-white'>Deadline Reminders</h3>
                <p>Send reminders before submission deadlines</p>
              </div>
            </div>

            <Switch name="isAllowDeadlineReminder" onChange={handleSwitchChange} checked={notiState.isAllowDeadlineReminder === "1"} />
          </div>

          <label className="deadline-checkbox-1">
            <input
              type="checkbox"
              checked={notiState.deadLinePriorityType === "3 days before deadline"}
              onChange={() =>
                handleChanleChange("deadLinePriorityType", "3 days before deadline")
              }
            />
            <span className="checkbox-custom-1"></span>
            <span className="checkbox-label-1 color-white">3 days before deadline</span>
            <span className="priority-badge high">High Priority</span>
          </label>

          <label className="deadline-checkbox-1">
            <input
              type="checkbox"
              checked={notiState.deadLinePriorityType === "2 days before deadline"}
              onChange={() =>
                handleChanleChange("deadLinePriorityType", "2 days before deadline")
              }
            />
            <span className="checkbox-custom-1"></span>
            <span className="checkbox-label-1 color-white">2 day before deadline</span>
            <span className="priority-badge critical">Critical</span>
          </label>

          <label className="deadline-checkbox-1">
            <input
              type="checkbox"
              checked={notiState.deadLinePriorityType === "1 days before deadline"}
              onChange={() =>
                handleChanleChange("deadLinePriorityType", "1 days before deadline")
              }
            />
            <span className="checkbox-custom-1"></span>
            <span className="checkbox-label-1 color-white">1 day before deadline</span>
            <span className="priority-badge urgent">Urgent</span>
          </label>


          <h3 className='color-gray font-14 font-weight-200 mt-3'>Notification Channels</h3>
          <div className="channels-section">

            <div className="channel-buttons mt-2">
              <ChannelButton
                icon={MdEmail}
                label="Email"
                active={notiState.deadLineNotificationChannel.includes("email")}
                onClick={() => toggleDeadLineNotificationChannel("email")}
              />

              <ChannelButton
                icon={MdMessage}
                label="SMS"
                active={notiState.deadLineNotificationChannel.includes("sms")}
                onClick={() => toggleDeadLineNotificationChannel("sms")}
              />
              <ChannelButton
                icon={MdNotifications}
                label="In-App"
                active={notiState.deadLineNotificationChannel.includes("inApp")}
                onClick={() => toggleDeadLineNotificationChannel("inApp")}
              />
            </div>
          </div>
        </div>


      </section>

      {/* ----------------- */}
      <section className="setting-border height-auto  mb-4">

        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'>
            <UserTie class_name={"section-icon text-purple"} />
            HR/Admin Notifications</h3>
          <span className='color-gray font-14'> 4 notification types</span>
        </div>

        <div className="p-4">

          <div className="time-window-sections">

            <div className='d-flex align-items-center justify-content-between gap-2'>
              <div className="section-header">
                <span className='padding-5-purple'>
                  <div className='two-icons' style={{ marginTop: "-4px", marginLeft: "9px", marginRight: "10px" }}><CircleDotted class_name="section-icon text-purple icon" /> <Question class_name="section-icon text-purple icon-1" /> </div>
                </span>
                <div>
                  <h3 className='color-white'>New Form Submissions</h3>
                  <p>Alert when employees submit new Form 12BB</p>
                </div>
              </div>

              <Switch name="isNewFormSubmission" onChange={handleSwitchChange} checked={notiState.isNewFormSubmission === "1"} />
            </div>

            <div className="time-inputs">
              <div className="time-input-group">
                <label>Notification Frequency</label>
                <Form.Group>
                  <Form.Select
                    name="formNotificationFreq"
                    value={notiState.formNotificationFreq}
                    onChange={handleInputChange}
                  >
                    <option value={""}>Select Notification Frequency</option>
                    <option value={"Immediate"}>Immediate</option>
                  </Form.Select>
                </Form.Group>
                {/* <button className="time-action-btn">
                  <MdAccessTime size={16} />
                </button> */}
              </div>

              <div className="time-input-group">
                <label>Batch Size</label>
                <Form.Group>
                  <Form.Select
                    name="formBatchSize"
                    value={notiState.formBatchSize}
                    onChange={handleInputChange}
                  >
                    <option value={""}>Select Batch Size</option>
                    <option value={"Individual notifications"}>Individual notifications</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>

          <h3 className='color-gray font-14 font-weight-200 mt-3'>Notification Channels</h3>
          <div className="channels-section">

            <div className="channel-buttons mt-2">
              <ChannelButton
                icon={MdEmail}
                label="Email"
                active={notiState.formNotificationChannel.includes("email")}
                onClick={() => toggleFormNotificationChannel("email")}
              />

              <ChannelButton
                icon={MdNotifications}
                label="In-App"
                active={notiState.formNotificationChannel.includes("inApp")}
                onClick={() => toggleFormNotificationChannel("inApp")}
              />
            </div>

          </div>
        </div>
      </section>

      {/* ----------------- */}
      <section className="setting-border height-auto  mb-4">
        <div className="p-4">

          <div className="time-window-sections">

            <div className='d-flex align-items-center justify-content-between gap-2'>
              <div className="section-header">
                <span className='padding-5-purple'>
                  <CloudUploadAlt class_name="section-icon text-purple" />
                </span>
                <div>
                  <h3 className='color-white'>Proof Uploads</h3>
                  <p>Notify when employees upload supporting documents</p>
                </div>
              </div>

              <Switch name="isAllowProofUpload" onChange={handleSwitchChange} checked={notiState.isAllowProofUpload === "1"} />
            </div>

            <div className="time-inputs">
              <div className="time-input-group">
                <label>Notification Mode</label>
                <Form.Group>
                  <Form.Select
                    name="proofUploadNotificationMode"
                    value={notiState.proofUploadNotificationMode}
                    onChange={handleInputChange}
                  >
                    <option value="">Notification Mode</option>
                    <option value="All uploads">All uploads</option>
                  </Form.Select>
                </Form.Group>
                {/* <button className="time-action-btn">
                  <MdAccessTime size={16} />
                </button> */}
              </div>

              <div className="time-input-group">
                <label>Priority Filter</label>
                <Form.Group>
                  <Form.Select
                    name="proofUploadPriorityFilter"
                    value={notiState.proofUploadPriorityFilter}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Priority Filter</option>
                    <option value={"All employees"}>All employees</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>

          <h3 className='color-gray font-14 font-weight-200 mt-3'>Notification Channels</h3>
          <div className="channels-section">

            <div className="channel-buttons mt-2">
              <ChannelButton
                icon={MdEmail}
                label="Email"
                active={notiState.proofUploadNotificationChannel.includes("email")}
                onClick={() => toggleProofUploadNotificationChannel("email")}
              />

              <ChannelButton
                icon={MdNotifications}
                label="In-App"
                active={notiState.proofUploadNotificationChannel.includes("inApp")}
                onClick={() => toggleProofUploadNotificationChannel("inApp")}
              />
            </div>

          </div>
        </div>
      </section>

      {/* -----------------  */}
      <section className="setting-border height-auto  mb-4">
        <div className="p-4">

          <div className="time-window-sections">

            <div className='d-flex align-items-center justify-content-between gap-2'>
              <div className="section-header">
                <span className='padding-5-purple'>
                  <HourglassHalf class_name="section-icon text-purple" />
                </span>
                <div>
                  <h3 className='color-white'>Pending Reviews Alert</h3>
                  <p>Alert when forms are pending review for too long</p>
                </div>
              </div>

              <Switch name="isAllowPendingReviewAlert" onChange={handleSwitchChange} checked={notiState.isAllowPendingReviewAlert === "1"} />
            </div>

            <div className="time-inputs">
              <div className="time-input-group">
                <label>Alert Threshold</label>
                <Form.Group>
                  <Form.Select
                    name="alertThreshold"
                    value={notiState.alertThreshold}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Alert Threshold</option>
                    <option value="1 day pending">1 day pending</option>
                  </Form.Select>
                </Form.Group>
                {/* <button className="time-action-btn">
                  <MdAccessTime size={16} />
                </button> */}
              </div>

              <div className="time-input-group">
                <label>Reminder Frequency</label>
                <Form.Group>
                  <Form.Select
                    name="reminderFreq"
                    value={notiState.reminderFreq}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Reminder Frequency</option>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>

          <h3 className='color-gray font-14 font-weight-200 mt-3'>Notification Channels</h3>
          <div className="channels-section">

            <div className="channel-buttons mt-2">
              <ChannelButton
                icon={MdEmail}
                label="Email"
                active={notiState.pendingReviewNotificationChannel.includes("email")}
                onClick={() => togglePendingReviewNotificationChannel("email")}
              />

              <ChannelButton
                icon={MdNotifications}
                label="In-App"
                active={notiState.pendingReviewNotificationChannel.includes("inApp")}
                onClick={() => togglePendingReviewNotificationChannel("inApp")}
              />
            </div>

          </div>
        </div>
      </section>

      {/* -----------------  */}
      <section className="setting-border height-auto  mb-4">
        <div className="p-4">

          <div className="time-window-sections">

            <div className='d-flex align-items-center justify-content-between gap-2'>
              <div className="section-header">
                <span className='padding-5-purple'>
                  <TriangleExclamation class_name="section-icon text-purple" />
                </span>
                <div>
                  <h3 className='color-white'>Escalation Notifications</h3>
                  <p>Escalate to managers when cases are stuck</p>
                </div>
              </div>

              <Switch name="isAllowEscalationNotification" onChange={handleSwitchChange} checked={notiState.isAllowEscalationNotification === "1"} />
            </div>

            <div className='warning-msg mb-4'>
              <TriangleExclamation class_name="section-icon warning-clr" />
              <div>
                <h5 className='font-weight-200'>Escalation Policy: Cases stuck for more than the threshold will be escalated to the reporting manager.</h5>
                <h5 className='font-weight-200'>This ensures timely resolution and prevents payroll delays.</h5>
              </div>
            </div>

            <div className="time-inputs">
              <div className="time-input-group">
                <label>Escalation Threshold</label>
                <Form.Group>
                  <Form.Select
                    name="escalationThreshold"
                    value={notiState.escalationThreshold}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Escalation Threshold</option>
                    <option value={"3 days stuck"}>3 days stuck</option>
                  </Form.Select>
                </Form.Group>
                {/* <button className="time-action-btn">
                  <MdAccessTime size={16} />
                </button> */}
              </div>

              <div className="time-input-group">
                <label>Escalation Level</label>
                <Form.Group>
                  <Form.Select
                    name="escalationLevel"
                    value={notiState.escalationLevel}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Escalation Level</option>
                    <option value="Direct Manager">Direct Manager</option>
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>

          <h3 className='color-gray font-14 font-weight-200 mt-3'>Notification Channels</h3>
          <div className="channels-section">

            <div className="channel-buttons mt-2">
              <ChannelButton
                icon={MdEmail}
                label="Email"
                active={notiState.escalationNotificationChannel.includes("email")}
                onClick={() => toggleEscalationNotificationChannel("email")}
              />

              <ChannelButton
                icon={MdSmartphone}
                label="Push"
                active={notiState.escalationNotificationChannel.includes("push")}
                onClick={() => toggleEscalationNotificationChannel("push")}
              />

              <ChannelButton
                icon={MdNotifications}
                label="In-App"
                active={notiState.escalationNotificationChannel.includes("inApp")}
                onClick={() => toggleEscalationNotificationChannel("inApp")}
              />
            </div>

          </div>
        </div>
      </section>
      {/* ----------------- */}

      <div className='setting-border height-auto d-flex align-items-center justify-content-between gap-2 p-4'>
        <div className='d-flex align-items-center gap-3'>
          <Clock class_name='color-white' />
          <span className='color-white font-14 font-weight-200'> Notification settings apply immediately after saving </span>
          <span className='color-gray font-12 font-weight-200'> 8 notification types configured • All channels active</span>
        </div>

        <button className='universal-btn border-radius-8px d-flex align-items-center gap-2 px-4 py-3' style={{ height: "40px" }} onClick={submitNotificationRules}> <Save /> Save Change</button>
      </div>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  )
}

export default Notifications